import type { Educando } from 'shared';
import { formatTime } from '@/lib/percurso';

/** Whole years from a "YYYY-MM-DD…" birth date to `today`. */
export function ageOn(dataNascimento: string, today: Date = new Date()): number {
  const [y, m, d] = dataNascimento.slice(0, 10).split('-').map(Number);
  const age = today.getFullYear() - y;
  const beforeBirthday =
    today.getMonth() + 1 < m || (today.getMonth() + 1 === m && today.getDate() < d);
  return beforeBirthday ? age - 1 : age;
}

export function educandoName(e: Pick<Educando, 'nome' | 'apelido'>): string {
  return `${e.nome} ${e.apelido}`.trim();
}

/** "No Centro agora · CCD Valongo, desde 15:02", or null when not at one. */
export function presenceText(e: Pick<Educando, 'presence'>): string | null {
  if (!e.presence) return null;
  return `${e.presence.digitalCenterName}, desde ${formatTime(e.presence.since)}`;
}
